export default "__VITE_ASSET__BmFWzVTD__"